import React from "react";
import { motion } from "framer-motion";

export default function SectionHeading({ eyebrow, title, subtitle, center = true, dark = false }) {
  return (
    <div className={`mb-12 ${center ? "text-center mx-auto max-w-2xl" : "max-w-2xl"}`}>
      {eyebrow && (
        <motion.p initial={{ opacity: 0, y: 10 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="eyebrow mb-3">
          {eyebrow}
        </motion.p>
      )}
      <motion.h2 initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}
        className={`font-display text-3xl sm:text-5xl font-extrabold leading-tight ${dark ? "text-white" : "text-[#f5f0ff]"}`}>
        {title}
      </motion.h2>
      {subtitle && (
        <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: 0.15 }}
          className={`mt-4 text-base ${dark ? "text-white/60" : "text-[#9aa0c0]"}`}>
          {subtitle}
        </motion.p>
      )}
    </div>
  );
}
